module.exports = __webpack_public_path__ + "img/48.42dd2895.jpg";